<div>
    <div class="break-words">
        <ng-content></ng-content>
    </div>
</div>